import { useRef, useState } from 'react';
import { Upload, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { adminApi } from '../../lib/api';
import { resolveImageUrl } from '../../lib/utils';

export const ImageUpload = ({ value, onChange }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setUploading(true);
    try {
      const res = await adminApi.uploadImage(file);
      onChange(res.data.url);
      toast.success('Fotoğraf yüklendi');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Fotoğraf yüklenemedi');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-3">
      {value && (
        <img data-testid="project-image-preview" src={resolveImageUrl(value)} alt="Kapak" className="w-full h-40 object-cover border" />
      )}
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={handleFile} data-testid="project-image-file-input" />
      <button
        type="button"
        data-testid="project-image-upload-btn"
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        className="w-full flex items-center justify-center gap-2 border border-dashed py-3 text-sm hover:bg-black/5 transition-colors disabled:opacity-60"
      >
        {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
        {uploading ? 'Yükleniyor...' : value ? 'Fotoğrafı Değiştir' : 'Fotoğraf Yükle'}
      </button>
      <p className="text-xs text-gray-500">JPG, PNG veya WEBP · en fazla 10 MB</p>
    </div>
  );
};
